var Item, _, beginSerialization, beginSerializeItem, deserializeItems, endSerialization, endSerializeItem, serializeItemBody;

_ = require('underscore-plus');

Item = require('../item');


/*
Serialization
 */

beginSerialization = function(items, options, context) {
  var coverItems, each, expandedItemIDs, expandedItemIDsSet, i, j, len, len1, outline, serializedItems;
  coverItems = Item.getCommonAncestors(items);
  expandedItemIDsSet = new Set();
  serializedItems = [];
  if (expandedItemIDs = options != null ? options.expandedItemIDs : void 0) {
    for (i = 0, len = expandedItemIDs.length; i < len; i++) {
      each = expandedItemIDs[i];
      expandedItemIDsSet.add(each);
    }
  }
  outline = null;
  for (j = 0, len1 = items.length; j < len1; j++) {
    each = items[j];
    if (outline == null) {
      outline = each.outline;
    }
    serializedItems.push({
      id: each.id,
      expanded: expandedItemIDsSet.has(each.id)
    });
  }
  return context.json = JSON.stringify({
    outlineID: outline.id,
    items: serializedItems
  });
};

beginSerializeItem = function(item, options, context) {};

serializeItemBody = function(item, bodyAttributedString, options, context) {};

endSerializeItem = function(item, options, context) {};

endSerialization = function(options, context) {
  return context.json;
};


/*
Deserialization
 */

deserializeItems = function(json, outline, options) {
  var Outline, each, expandedItemIDs, i, item, items, len, ref, sourceOutline;
  Outline = require('../outline');
  json = JSON.parse(json);
  items = [];
  expandedItemIDs = [];
  items.loadOptions = {
    expanded: expandedItemIDs
  };
  sourceOutline = Outline.getOutlineForID(json.outlineID);
  if (sourceOutline) {
    ref = json.items;
    for (i = 0, len = ref.length; i < len; i++) {
      each = ref[i];
      if (item = sourceOutline.getItemForID(each.id)) {
        items.push(item);
        if (each.expanded) {
          expandedItemIDs.push(each.id);
        }
      }
    }
  }
  return Item.getCommonAncestors(items);
};

module.exports = {
  beginSerialization: beginSerialization,
  beginSerializeItem: beginSerializeItem,
  serializeItemBody: serializeItemBody,
  endSerializeItem: endSerializeItem,
  endSerialization: endSerialization,
  deserializeItems: deserializeItems
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/serializations/item-references.js
 ** module id = 74
 ** module chunks = 0
 **/